import { render, staticRenderFns } from "./GestionRiesgos.vue?vue&type=template&id=38c334b6&"
import script from "./GestionRiesgos.vue?vue&type=script&lang=js&"
export * from "./GestionRiesgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports